/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import CarouselExample from '../examples/Carousel';
import CarouselVerticalDirectionExample from '../examples/CarouselVerticalDirection';
const CarouselExampleSource = require('!!raw-loader!../examples/Carousel');
const CarouselVerticalDirectionExampleSource = require('!!raw-loader!../examples/CarouselVerticalDirection');
export default class CarouselPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Carousel"/>

                <h3>Carousel</h3>
                <div className="docs-example">
                    <CarouselExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CarouselExampleSource}</PrismCode>
                </pre>

                <h3>Carousel allow only vertical direction</h3>
                <div className="docs-example bg-light">
                    <CarouselVerticalDirectionExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CarouselVerticalDirectionExampleSource}</PrismCode>
                </pre>

                <h3>Carousel Properties</h3>
                <pre>
                    <PrismCode className="language-jsx">
                        {`Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: PropTypes.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: PropTypes.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: PropTypes.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: PropTypes.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: PropTypes.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: PropTypes.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  interval: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  children: PropTypes.array,
  // called when the mouse enters the Carousel
  mouseEnter: PropTypes.func,
  // called when the mouse exits the Carousel
  mouseLeave: PropTypes.func,
  cssModule: PropTypes.object,
};`}
                    </PrismCode>
                </pre>

                <h3>CarouselItem Properties</h3>
                <pre>
                    <PrismCode className="language-jsx">
                        {`CarouselItem.propTypes = {
  ...Transition.propTypes,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  in: PropTypes.bool,
  cssModule: PropTypes.object,
  children: PropTypes.node,
};`}
                    </PrismCode>
                </pre>

                <h3>CarouselControl Properties</h3>
                <pre>
                    <PrismCode className="language-jsx">
                        {`CarouselControl.propTypes = {
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.instanceOf(SvgIcon),
  isActive: PropTypes.bool
  placement: PlacementType
};`}
                    </PrismCode>
                </pre>

                <h3>CarouselIndicators Properties</h3>
                <pre>
                    <PrismCode className="language-jsx">
                        {`CarouselIndicators.propTypes = {
  items: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  cssModule: PropTypes.object,
  onClickHandler: PropTypes.func.isRequired,
  // position-outer || position-inner
  className: PropTypes.string
};`}
                    </PrismCode>
                </pre>

                <h3>CarouselCaption Properties</h3>
                <pre>
                    <PrismCode className="language-jsx">
                        {`CarouselCaption.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageWidth: PropTypes.number.isRequired,
  imageHeight: PropTypes.number.isRequired,
  imageSrcSet: PropTypes.object,
  imageSizes: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  roundedImage: PropTypes.boolean,
  verticalDirection: PropTypes.boolean,
|};

CarouselCaption.defaultProps = {
    roundedImage: true,
    verticalDirection: false,
    imageSrcSet: null,
    imageSizes: null,
};
`}
                    </PrismCode>
                </pre>
            </div>);
    }
}
